var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},_vm._l((_vm.getBtns),function(item,index){return _c('span',{key:index,staticClass:"btn",on:{"click":function($event){_vm.handleChange(item.key)}}},[_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72fe6430","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMTable/components/tdBox/components/buttons/index.vue
// module id = null
// module chunks = 